// Paydaai – kurumsal/yasal sayfa linkleri.
// Buradaki URL'leri kendi web sitenizdeki sayfalara yönlendirebilirsiniz.
export const LEGAL_LINKS = {
  kvkk: 'https://paydaai.com/kvkk-aydinlatma-metni',
  privacy: 'https://paydaai.com/gizlilik-politikasi',
  termsOfService: 'https://paydaai.com/kullanim-sartlari',
  distanceSales: 'https://paydaai.com/mesafeli-satis',
};
